const fraudMonitor = [
  {
    title: 'Fraud Monitor',
    icon: 'MonitorIcon',
    enableFeature: true,
    children: [
      {
        title: 'Blacklist',
        route: 'black-list',
        hasPermission: 'VIEW_BLACKLIST',
        enableFeature: true,
      },
      {
        title: 'Whitelist',
        route: 'white-list',
        hasPermission: 'VIEW_WHITELIST',
        enableFeature: true,
      },
      {
        title: 'Rule',
        route: 'transaction-rule',
        hasPermission: 'VIEW_TRANSACTION_RULE',
        enableFeature: true,
      },
      {
        title: 'Suspicious Transaction Report',
        route: 'suspicious-transaction-report',
        hasPermission: 'VIEW_SUSPICIOUS_TRANSACTION_REPORT',
        enableFeature: true,
      },
      {
        title: 'Sanction Screening',
        route: 'sanction-screening',
        hasPermission: 'VIEW_SANCTIONED_LIST',
        enableFeature: true,
      },
    ],
  },
]

export default fraudMonitor
